export const URL_API = "https://areco.gob.ar:9525/api";